import React from "react";
import './toggleSwitch.css'
function ToggleSwitch(props) {
    const {
        text,
        size = "default",
        checked,
        disabled,
        onChange,
        offstyle = "btn-custom-3",
        onstyle = "btn-custom-1"
    } = props;

    let displayStyle = checked ? onstyle : offstyle;
    return (
        <div className={'toggle-switch'}>
            <label className="toggle-label">
        <span className={`${size} switch-wrapper`}>
          <input
              type="checkbox"
              checked={checked}
              disabled={disabled}
              onChange={e => onChange(e)}
          />
          <span className={`${displayStyle} switch`}>
            <span className="switch-handle" />
          </span>
        </span>
                <span className="switch-label">{text}</span>
            </label>
        </div>
    );
}

export default ToggleSwitch;
